<template lang="pug">
tr.vue-time-entries-row.time-entry-row
  td
    AppCheckbox(disabled)
  td
    .project-cell-wrapper
      AppAvatarInitial(:text="project.text")
      .time-entry-data.inline-block
        .project
          .inline-block(
            v-tooltip="true"
            :title="timeEntry.tooltip"
          )
            .name.strong
              | {{ projectName }}
        strong.hi-10.org-name.is-uppercase.text-lighter
          | {{ organizationName }}
        .task
          .inline-block(
            v-tooltip="true"
            :title="timeEntry.tooltip"
          )
            .name
              | {{ taskName }}
  td(v-if="tableColumns.show_reasons && reasonsOrNotesArePresent")
    table.reasons-table(v-if="!timeEntryIsEmpty")
      tr(v-if="timeEntry.note")
        td.text-light
          .text-overflow
            | {{ timeEntry.note }}
      tr(v-if="timeEntry.work_note")
        td.strong.pr-5 Note:
        td.text-light
          .text-overflow
            | {{ timeEntry.work_note }}
  td(v-if="tableColumns.show_activity && showActivityColumns")
    .inline-block
      span(v-if="timeEntryIsEmpty") —
      span(v-else) 0%

  td(v-if="tableColumns.show_idle && showActivityColumns")
    span(v-if="timeEntryIsEmpty") —
    span(v-else) 0%
  td
    .inline-block
      | {{ manualPercentage }}
  td
    .inline-block
      TimeEntriesFormPopover(
        v-if="timeEntryIsEmpty"
        type="new"
        :time-entry="timeEntrySkeleton"
        :time-entries="timeEntries"
        @replace-time-entry="replaceTimeEntry"
      )
        a.a-popover Add
      span(
        v-else
        v-tooltip="{ placement: 'top' }"
        :data-original-title="disabledTooltip"
      )
        | {{ $filters.formatDuration(timeEntry.tracked) }}
      i.fa.fa-dollar.a-tooltip.ml-5(
        v-if="timeEntry.billable"
        v-tooltip="{ placement: 'right' }"
        title="Billable time"
      )
  td
    TimeEntriesFormPopover(
      v-if="timeEntryIsEmpty"
      type="new"
      :time-entry="timeEntrySkeleton"
      :time-entries="timeEntries"
      @replace-time-entry="replaceTimeEntry"
    )
      a.a-popover Add
    span(
      v-else
      v-tooltip="{ placement: 'top' }"
      :data-original-title="disabledTooltip"
    )
      | {{ formattedDatetimeRange }}
  td.actions
    .inline-block(
      v-tooltip="{ placement: 'top' }"
      :data-original-title="disabledTooltip"
    )
      a.btn.btn-sm.btn-default.dropdown-toggle.disabled
        | Actions
        i.hi.hi-caret.hi-10
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash-es';
import { formatDatetimeRange } from '~/utils/time_utils';
export default {
  name: 'TimeEntriesCopyRow',
  props: {
    timeEntrySkeleton: Object,
    timeEntries: {
      type: Array,
      default: () => [],
    },
    reasonsOrNotesArePresent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timeEntry: {},
    };
  },
  computed: {
    ...mapGetters([
      'getOrganization',
      'getProject',
      'getTask',
      'currentZone',
      'showActivityColumns',
      'tableColumns',
      'projectFlavour',
    ]),
    timeEntryIsEmpty() {
      return isEmpty(this.timeEntry);
    },
    organizationName() {
      const organization = this.getOrganization(this.timeEntrySkeleton.organization_id);

      return organization.name;
    },
    project() {
      return this.getProject(this.timeEntrySkeleton.project_id);
    },
    projectName() {
      return this.project.text;
    },
    formattedDatetimeRange() {
      return formatDatetimeRange(this.timeEntry.start_time, this.timeEntry.stop_time, {
        style: 'time',
        showSeconds: 'auto',
        timezone: this.currentZone.name,
      });
    },
    disabledTooltip() {
      return this.timeEntryIsEmpty ? null : 'Refresh page to edit';
    },
    emptyTaskString() {
      if (this.project.work_order) {
        return 'No job';
      }

      return 'No to-do';
    },
    taskName() {
      const task = this.getTask(this.timeEntrySkeleton.task_id);

      return task ? task.text : this.emptyTaskString;
    },
    manualPercentage() {
      return this.timeEntryIsEmpty ? '—' : '100%';
    },
  },
  methods: {
    replaceTimeEntry(timeEntry) {
      this.timeEntry = timeEntry;
      this.$emit('add-time-entry', timeEntry);
    },
  },
};
</script>
